import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import NursingListBody from "components/PatientManagement/Nursing/NursingListBody";

export default function Nursing() {
  useEffect(() => {
    document.title = "Nursing";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <NursingListBody />
    </main>
  );
}
